export const combineFields = (firstField, secondField) => {
  const combinedFields = [firstField, secondField].filter(Boolean).join("-");
  return combinedFields;
};
